import walletConnectModule from "@web3-onboard/walletconnect";

export default walletConnectModule();
